import React from 'react';
import styles from './Checkbox.module.css';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Visible label. Accepts rich content (e.g. a required asterisk or a note). */
  label?: React.ReactNode;
  /** Associates the label with the input via htmlFor/id. */
  id: string;
  /** Extra class for the wrapping `.uc-form-check` container. */
  className?: string;
}

/**
 * UC checkbox (kit `.uc-form-check`). Forwards its ref to the native input and spreads
 * arbitrary input props, so it works both controlled (`checked`/`onChange`) and uncontrolled
 * with react-hook-form's `register()` (which supplies name/onChange/onBlur/ref). It must NOT
 * default `checked`, otherwise the input becomes permanently controlled and RHF's uncontrolled
 * registration breaks.
 */
const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, id, className = '', ...props }, ref) => (
    <div className={`uc-form-check ${styles.checkboxGroup} ${className}`}>
      <input type="checkbox" id={id} ref={ref} className={styles.input} {...props} />
      {label !== '' && label != null && (
        <label htmlFor={id} className={styles.label}>
          <span className={styles.checkmark}></span>
          {label}
        </label>
      )}
    </div>
  )
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
